<!--首购订单(代办处)-->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container recharge-manage">
      <div v-if="registerIF === 0">
        <el-form label-width="130px">
          <el-row :gutter="20">
            <el-col :md="8" :lg="8" :xl="8">
              <el-form-item size="mini"  :label="$t('miMember.memberNo')">
                <el-input v-model.trim="memberNo" clearable @blur="getAgentno()" />
              </el-form-item>
            </el-col>
            <el-col :md="12" :lg="8" :xl="6">
              <p :class="{ 'account_name_css': account_name_show}" style="color:#538E0D; font-weight:bold; line-height: 4px;">{{ memberNo_span }}</p>
            </el-col>
          </el-row>
        </el-form>
        <p style="margin-left: 43px">{{$t('New.Distributor')}}<span style="color: #1791e6; cursor: pointer;" @click="registerIF = 2">{{$t('Click.Here')}}</span></p>
        <div style="text-align: center; margin-bottom: 10px">
          <!--      下一步-->
          <el-button size="mini" v-loading="saveLoading" :disabled="oneNextIf" type="success" icon="el-icon-right" @click="btnNextStep">{{ $t('button.next') }}</el-button>
          <!--      取消-->
          <el-button size="mini" type="danger" icon="el-icon-close" @click="btnCancel()">{{ $t('operation.button.cancel') }}</el-button>
        </div>
      </div>
      <div v-if="registerIF === 1">
        <el-form>
          <!-- 基本信息 -->
          <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
          <!-- 经销商编号 -->
          <el-form-item :label="$t('miMember.memberNo')+ ':'">
            {{ commodityInfoTwo.memberNo }}
          </el-form-item>
          <!-- 推荐人编号 -->
          <el-form-item :label="$t('mi.sellerNo')+ ':'">
            {{ commodityInfoTwo.recommendNo }}
          </el-form-item>
          <!-- 安置人编号 -->
          <el-form-item v-if="companyCode !== 'BD'" :label="$t('mi.servicerNo')+ ':'">
            {{ commodityInfoTwo.linkNo }}
          </el-form-item>
        </el-form>
        <h3 style="color: #b3640d">{{ $t('mall.ProductsList') }}</h3>
        <p style="color:#538E0D; font-size:14px; font-weight:bold;">
          {{$t('busi.finance.amount')}}<span  style="color:#F00; font-size:14px; font-weight:bold;">{{totalfA}}</span>
          FV <span  style="color:#F00; font-size:14px; font-weight:bold;">{{totalFv}}</span>
        </p>
        <el-table
            :data="list"
            border
            size="mini"
            height="500"
            fit
            highlight-current-row
            style="width: 100%;"
        >
          <!--     预览 -->
          <!--<el-table-column :label="$t('button.preview')" prop="photoName" align="center" />-->
          <!--     商品编码(旧) -->
          <el-table-column :label="$t('Old_goodsCode')" prop="oldcode" align="center" />
          <!--      商品编码-->
          <el-table-column :label="$t('BiGoods.goodsCode')" prop="goodscode" align="center" />
          <!--      商品名称-->
          <el-table-column :label="$t('BiGoods.name')" prop="name" align="center" />
          <!--      价格-->
          <el-table-column :label="$t('pd.price')" prop="standardPrice" align="center" />
          <!--      积分-->
          <el-table-column :label="$t('busi.direct.sale_points')" prop="standardPv" align="center" />
          <!--      可用库存量-->
          <el-table-column :label="$t('stStock.validQty')" prop="validQty" align="center" />
          <!--      购买数量-->
          <el-table-column :label="$t('Common.buyNumber')" prop="buyQty" align="center" >
            <template v-slot="{row}">
              <el-input v-model.number="row.buyQty"  />
            </template>
          </el-table-column>
        </el-table>
        <el-form label-width="150px">
          <!--         支付密码 -->
          <el-form-item size="mini" style="width: 400px;margin-top: 10px"  :label="$t('please.input.your.pay.password')" :rules="{ required: true, message: this.$t('po.setInfo'), trigger: ['blur', 'change'] }">
            <el-input v-model.trim="payPassword" show-password clearable :placeholder="$t('')"  />
          </el-form-item>
        </el-form>
        <div style="text-align: center; margin-bottom: 10px;margin-top: 10px">
          <!--      上一步-->
          <el-button size="mini" v-loading="saveLoading" type="primary" icon="el-icon-back" @click="registerIF = 0">{{ $t('button.previous') }}</el-button>
          <!--        提交-->
          <el-button size="mini" v-loading="saveLoading" type="success" icon="el-icon-check" @click="titlesubmit()">{{ $t('title.submit') }}</el-button>
          <!--      取消-->
          <el-button size="mini" type="danger" icon="el-icon-close" @click="btnCancel()">{{ $t('operation.button.cancel') }}</el-button>
        </div>
      </div>
      <!--注册-->
      <div v-if="registerIF === 2">
        <p>{{$t('Existing.Distributor')}}<span style="color: #1791e6; cursor: pointer;" @click="registerIF = 0">{{$t('Click.Here')}}</span></p>
        <el-form ref="registerRef" :model="registerInfo" :rules="rules" label-width="130px" size="mini">
          <!-- 基本信息 -->
          <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
          <!-- 推荐人编号 -->
          <el-form-item :label="$t('mi.sellerNo')+ ':'" prop="recommendNo">
            <el-input v-model.trim="registerInfo.recommendNo" clearable style="width: 80%" @blur="recommendNoBlur($event.target.value)"/>
            <span :class="{ 'account_name_css':  recommendName_span_show}" class="red-span">{{ recommendName_span }}</span>
          </el-form-item>
          <!-- 安置人编号 -->
          <el-form-item v-if="this.companyCode !== 'BD'" :label="$t('mi.servicerNo')+ ':'" prop="linkNo">
            <el-input v-model.trim="registerInfo.linkNo" clearable style="width: 80%" @blur="tmpLinkNoBlur($event.target.value)"/>
            <span :class="{ 'account_name_css':  tmpLinkNo_span_show}" class="red-span">{{ tmpLinkNo_span }}</span>
            <br>
            <span v-if="tmpLinkNo_num_span" class="red-span">温馨提示:该服务商已拥有{{ tmpLinkNo_num_span }}个市场，请确认是否继续放置在其下</span>
          </el-form-item>
          <!-- 经销商姓名 -->
          <el-form-item :label="$t('miMember.name')+ ':'" prop="name">
            <el-input v-model="registerInfo.name" clearable style="width: 80%" @blur="registerInfo.accountName = registerInfo.name"/>
          </el-form-item>
          <!-- 证件类型 -->
          <el-form-item :label="$t('miAgent.paperType') + ':'" prop="paperType">
            <el-select v-if="BonusType !== '13'" v-model="registerInfo.paperType" style="width: 80%">
              <el-option v-for="item in NeBonusTypeList" :label="$lt(initDict.NeBonusType, item.code)" :key="item.code"  :value="item.code" />
            </el-select>
            <el-select v-else-if="BonusType === '13'" v-model="registerInfo.paperType" style="width: 80%">
              <el-option v-for="item in EqBonusTypeList" :label="$lt(initDict.EqBonusType, item.code)" :key="item.code"  :value="item.code" />
            </el-select>
          </el-form-item>
          <!-- 证件号 -->
          <el-form-item :label="$t('miAgent.paperNo')+ ':'" prop="paperNo">
            <el-input v-model.trim="registerInfo.paperNo" clearable style="width: 80%" @blur="paperNoBlur($event.target.value)"/>
            <span style="color: red">{{ this.paperNoError }}</span>
          </el-form-item>
          <!-- 联系资料 -->
          <h3 style="color: #b3640d">{{ $t('mi.lable.contact.info') }}</h3>
          <!-- 所在地区 -->
          <el-form-item :label="$t('miAgent.regionCode')+ ':'">
            <!--            国-->
            <el-select size="mini" style="width: 160px" v-model="registerInfo.country" clearable :placeholder="$t('please.select.country.or.region')" @change="getProvince">
              <el-option value="" />
              <el-option  v-for="role in country" :key="role.regionId" :label="(role.regionName)" :value="role.regionCode"  />
            </el-select>
            <!--            省-->
            <el-select size="mini" v-loading="sltloading" style="width: 160px" v-model="registerInfo.province" clearable :placeholder="$t('please.select.province')" @change="getcity">
              <el-option value="" />
              <el-option v-for="role in province" :key="role.regionId" :label="(role.regionName)" :value="role.regionCode" />
            </el-select>
            <!--            市-->
            <el-select size="mini" v-loading="sltloading" style="width: 160px" v-model="registerInfo.city" clearable :placeholder="$t('please.select.city')" @change="getdistrict">
              <el-option value="" />
              <el-option v-for="role in city" :key="role.regionId" :label="(role.regionName)" :value="role.regionCode" />
            </el-select>
            <!--            县-->
            <el-select size="mini" v-loading="sltloading" style="width: 160px" v-model="registerInfo.district" clearable :placeholder="$t('please.select.district.or.county')">
              <el-option value="" />
              <el-option v-for="role in district" :key="role.regionId" :label="(role.regionName)" :value="role.regionCode" />
            </el-select>
          </el-form-item>
          <!-- 详细地址 -->
          <el-form-item :label="$t('miAgent.storeAddr')+ ':'" prop="storeAddr">
            <el-input v-model.trim="registerInfo.storeAddr" clearable style="width: 80%" />
          </el-form-item>
          <!-- 邮政编码 -->
          <el-form-item :label="$t('miAgent.storePost')+ ':'" >
            <el-input v-model.trim="registerInfo.storePost" clearable style="width: 80%"/>
          </el-form-item>
          <!-- 传真 -->
          <el-form-item :label="$t('biVendor.fax')+ ':'">
            <el-input v-model.trim="registerInfo.fax" clearable style="width: 80%"/>
          </el-form-item>
          <!-- 移动电话 -->
          <el-form-item :label="$t('miAgent.mobile')+ ':'" prop="mobile">
            <el-input v-model.trim="registerInfo.mobile" clearable style="width: 80%"/>
          </el-form-item>
          <!-- 银行账户信息 -->
          <h3 style="color: #b3640d">{{ $t('miAgent.title.accountInfo') }}</h3>
          <!-- 开户银行 -->
          <el-form-item :label="$t('miAgent.accountBank') + ':'" >
            <el-select v-if="BonusType === '12'" v-model="registerInfo.accountBank" style="width: 80%">
              <el-option v-for="item in accountBankTwoList" :key="item.code" :label="item.title" :value="item.code" />
            </el-select>
            <el-select v-else-if="BonusType === '11'" v-model="registerInfo.accountBank" style="width: 80%">
              <el-option v-for="item in accountBankOneList" :key="item.code" :label="item.title" :value="item.code" />
            </el-select>
            <el-select v-else-if="BonusType === '13'" v-model="registerInfo.accountBank" style="width: 80%">
              <el-option v-for="item in accountBankThreeList" :key="item.code" :label="item.title" :value="item.code" />
            </el-select>
            <el-input v-else-if="BonusType === '16'"  v-model="registerInfo.accountBank" clearable style="width: 80%"/>
          </el-form-item>
          <!-- 银行代码 -->
          <el-form-item :label="$t('Routing.Number')+ ':'"  required>
            <el-input v-model.trim="registerInfo.routingNumber" clearable style="width: 80%"/>
          </el-form-item>
          <!-- 分行名称 -->
          <el-form-item  :label="$t('Branch.Name')+ ':'" required>
            <el-input v-model.trim="registerInfo.branchName" clearable style="width: 80%"/>
          </el-form-item>
          <!-- 户名 -->
          <el-form-item :label="$t('miAgent.accountName')+ ':'" >
            <el-input v-model.trim="registerInfo.accountName" @blur="registerInfo.name = registerInfo.accountName" clearable style="width: 80%"/>
          </el-form-item>
          <!-- 账号 -->
          <el-form-item :label="$t('miAgent.accountCode')+ ':'" >
            <el-input v-model.trim="registerInfo.accountCode" clearable style="width: 80%"/>
          </el-form-item>
          <!-- 密码设置 -->
          <h3 style="color: #b3640d">{{ $t('miAgent.title.LoginInfo') }}</h3>
          <!-- 设置密码 -->
          <el-form-item :label="$t('sysUser.password')+ ':'" prop="password">
            <el-input v-model.trim="registerInfo.password" clearable style="width: 80%" show-password/>
            <div style="color:red;">{{$t('sys.require.numandletter.cn')}}</div>
          </el-form-item>
          <!-- 重复密码 -->
          <el-form-item :label="$t('sysUser.repeatPassword')+ ':'" prop="advPassword">
            <el-input v-model.trim="registerInfo.advPassword" clearable style="width: 80%" show-password/>
            <div style="color:red;">{{$t('sys.same.payanduser')}}</div>
          </el-form-item>
        </el-form>
        <div style="text-align: center; margin-bottom: 10px">
          <!--      下一步-->
          <el-button size="mini" v-loading="saveLoading" type="success" icon="el-icon-right" @click="btnRegisterInfoSave">{{ $t('button.next') }}</el-button>
          <!--      取消-->
          <el-button size="mini" type="danger" icon="el-icon-close" @click="btnCancel()">{{ $t('operation.button.cancel') }}</el-button>
        </div>
      </div>
      <!--  注册后选择商品信息-->
      <div v-if="registerIF === 3">
        <el-form class="register_3_css">
          <div style="flex: 1">
            <!-- 基本信息 -->
            <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
            <!-- 推荐人编号 -->
            <el-form-item :label="$t('mi.sellerNo')+ ':'">
              {{ commodityInfo.recommendNo }}
            </el-form-item>
            <!-- 安置人编号 -->
            <el-form-item v-if="companyCode !== 'BD'" :label="$t('mi.servicerNo')+ ':'">
              {{ commodityInfo.linkNo }}
            </el-form-item>
            <!-- 经销商姓名 -->
            <el-form-item :label="$t('miMember.name')+ ':'">
              {{ commodityInfo.name }}
            </el-form-item>
            <!-- 证件类型 -->
            <el-form-item :label="$t('miAgent.paperType')+ ':'">
              {{ $lt(initDict.NeBonusType, commodityInfo.paperType) }}
            </el-form-item>
            <!-- 证件号 -->
            <el-form-item :label="$t('miAgent.paperNo')+ ':'">
              {{ commodityInfo.paperNo }}
            </el-form-item>
            <!-- 奖金发放方式 -->
            <el-form-item :label="$t('bd.bonusSendType')+ ':'">
              {{ $lt(initDict.sendType, commodityInfo.bonusSendType) }}
            </el-form-item>
          </div>
          <div style="flex: 1">
            <!-- 银行账户信息 -->
            <h3 style="color: #b3640d">{{ $t('miAgent.title.accountInfo') }}</h3>
            <!-- 开户银行 -->
            <el-form-item :label="$t('miAgent.accountBank')+ ':'">
              {{ commodityInfo.accountBank }}
            </el-form-item>
            <!-- 户名 -->
            <el-form-item :label="$t('miAgent.accountName')+ ':'">
              {{ commodityInfo.accountName }}
            </el-form-item>
            <!-- 账号 -->
            <el-form-item :label="$t('miAgent.accountCode')+ ':'">
              {{ commodityInfo.accountCode }}
            </el-form-item>
            <!-- 联系资料 -->
            <h3 style="color: #b3640d">{{ $t('mi.lable.contact.info') }}</h3>
            <!-- 移动电话 -->
            <el-form-item :label="$t('miAgent.mobile')+ ':'">
              {{ commodityInfo.mobile }}
            </el-form-item>
            <!-- 传真 -->
            <el-form-item v-if="commodityInfo.officeTel" :label="$t('biVendor.fax')+ ':'">
              {{ commodityInfo.officeTel }}
            </el-form-item>
            <!-- 详细地址 -->
            <el-form-item :label="$t('miAgent.storeAddr')+ ':'">
              {{ commodityInfo.storeAddr }}
            </el-form-item>
            <!-- 邮政编码 -->
            <el-form-item v-if="commodityInfo.officeTel" :label="$t('miAgent.storePost')+ ':'">
              {{ commodityInfo.storePost }}
            </el-form-item>
          </div>
        </el-form>
        <!-- 商品列表 -->
        <h3 style="color: #b3640d">{{ $t('mall.ProductsList') }}</h3>
        <p style="color:#538E0D; font-size:14px; font-weight:bold;">
          {{$t('busi.finance.amount')}} <span  style="color:#F00; font-size:14px; font-weight:bold;">{{totalfA}}</span>
          FV <span  style="color:#F00; font-size:14px; font-weight:bold;">{{totalFv}}</span>
        </p>
        <el-table
            :data="list"
            height="500"
            border
            size="mini"
            fit
            highlight-current-row
            style="width: 100%;"
        >
          <!--     预览 -->
          <!--<el-table-column :label="$t('button.preview')" prop="photoName" align="center" />-->
          <!--     商品编码(旧) -->
          <el-table-column :label="$t('Old_goodsCode')" prop="oldcode" align="center" />
          <!--      商品编码-->
          <el-table-column :label="$t('BiGoods.goodsCode')" prop="goodscode" align="center" />
          <!--      商品名称-->
          <el-table-column :label="$t('BiGoods.name')" prop="name" align="center" />
          <!--      价格-->
          <el-table-column :label="$t('pd.price')" prop="standardPrice" align="center" />
          <!--      积分 busi.direct.sale_points-->
          <el-table-column :label="$t('PV')" prop="standardPv" align="center" />
          <!--      可用库存量-->
          <el-table-column :label="$t('stStock.validQty')" prop="validQty" align="center" />
          <!--      购买数量-->
          <el-table-column :label="$t('Common.buyNumber')" prop="buyQty" align="center" >
            <template v-slot="{row}">
              <el-input v-model.number="row.buyQty"  />
            </template>
          </el-table-column>
        </el-table>
        <el-form label-width="150px">
          <!--         支付密码 -->
          <el-form-item size="mini" style="width: 400px;margin-top: 10px"  :label="$t('please.input.your.pay.password')" :rules="{ required: true, message: this.$t('po.setInfo'), trigger: ['blur', 'change'] }">
            <el-input v-model.trim="saveInfo.payPassword" show-password clearable :placeholder="$t('')"  />
          </el-form-item>
        </el-form>
        <div style="text-align: center; margin-bottom: 10px">
          <!--        上一步-->
          <el-button size="mini" v-loading="saveLoading" type="primary" icon="el-icon-back" @click="registerIF = 2">{{ $t('button.previous') }}</el-button>
          <!--        提交-->
          <el-button size="mini" v-loading="saveLoading" type="success" icon="el-icon-check" @click="btnSubmit()">{{ $t('title.submit') }}</el-button>
          <!--        取消-->
          <el-button size="mini" type="danger" icon="el-icon-close" @click="btnCancel()">{{ $t('operation.button.cancel') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getAlRegionsByCode, getCompanyBonusType, getLevel1AlRegions, miMemberInfo, miMemberRightNum} from "@/api/member"
import {
  agentRegisterFirst,
  agentRegisterSecond,
  goodsListSGByMember,
  saveSGA
} from "@/api/ay-business-manager/firstpurchaseorder"
import {mapGetters} from "vuex"

export default {
  name: "FirstpurchaseOrderAgent",
  data() {
    return {
      paperNoError: '',
      resSaveInfo: false,
      btnLoading: false,
      saveLoading: false,
      commodityInfoTwo: {
        memberNo: '',
        recommendNo: '',
        linkNo: '',
      },
      payPassword: '',
      saveInfo: {
        payPassword: '',
      },
      commodityInfo: {
        recommendNo: '',
        linkNo: '',
        name: '',
        paperType: '',
        paperNo: '',
        bonusSendType: '',
        mobile: '',
        accountBank: '',
        accountName: '',
        accountCode: '',
        officeTel: '',
        storeAddr: '',
        storePost: '',
      },
      BonusType: '',
      list: [],
      recommendName_span_show: false,
      tmpLinkNo_span_show: false,
      recommendName_span: '',
      tmpLinkNo_span: '',
      tmpLinkNo_num_span: '',
      memberNo_span: '',
      registerIF: 0,
      registerInfo: {
        recommendNo: '',
        linkNo: '',
        name: '',
        paperType: '1',
        paperNo: '',
        country: '',
        province: '',
        city: '',
        district: '',
        storeAddr: '',
        storePost: '',
        fax: '',
        mobile: '',
        accountBank: '',
        accountName: '',
        accountCode: '',
        password: '',
        advPassword: ''
      },
      account_name_show: false,
      oneNextIf: true,
      memberNo: '',
      accountName: '',
      // 地区
      sltloading: false,
      country:null,
      province:null,
      city:null,
      district:null,
      rules: {
        recommendNo: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        linkNo: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        name: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        paperType: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        paperNo: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        country: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        storeAddr: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        mobile: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        accountBank: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        accountName: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        accountCode: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
        password: [{required: true, message: this.$t('sys.require.numandletter.cn'), trigger: '[blur, change]'}],
        advPassword: [{required: true, message: this.$t('label.pleaseFillIn'), trigger: '[blur, change]'}],
      },
      initDict: {
        NeBonusType: 'miagent.papertype',
        EqBonusType: 'id.miagent.papertype',
        accountBankTwo: 'in.bank.list',
        accountBankOne: 'mm.bank.list',
        accountBankThree: 'ind.bank.list',
        sendType: 'bd.bonus_send_type'
      }
    }
  },
  computed: {
    ...mapGetters([
      'companyCode'
    ]),
    totalfA() {
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc, cur) => {
        return cur.standardPrice * cur.buyQty + acc
      }, 0).toFixed(2)
    },
    totalFv() {
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc, cur) => {
        return cur.standardPv * cur.buyQty + acc
      }, 0).toFixed(2)
    },
    buyQty() {
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc, cur) => {
        return cur.buyQty + acc
      }, 0)
    },
    NeBonusTypeList() {
      return this.$ll(this.initDict.NeBonusType)
    },
    EqBonusTypeList() {
      return this.$ll(this.initDict.EqBonusType)
    },
    accountBankTwoList() {
      return this.$ll(this.initDict.accountBankTwo)
    },
    accountBankOneList() {
      return this.$ll(this.initDict.accountBankOne)
    },
    accountBankThreeList() {
      return this.$ll(this.initDict.accountBankThree)
    }
  },
  created() {
    this.getBonusType()
    this.getGoodsList()
    this.getCountry()
  },
  methods: {
    getAgentno(){
      if (this.memberNo) {
        miMemberInfo({'memberNo': this.memberNo}).then(res => {
          this.memberNo_span = res.data.accountName
          this.oneNextIf = false
          this.account_name_show = false
        }).catch(() => {
          this.account_name_show = true
          this.memberNo_span = ''
          this.oneNextIf = true
        })
      } else {
        this.memberNo_span = ''
        this.oneNextIf = true
        this.account_name_show = false
      }
    },
    btnNextStep() {
      this.saveLoading = true
      miMemberInfo({'memberNo': this.memberNo}).then(res => {
        this.commodityInfoTwo.memberNo = res.data.memberNo
        this.commodityInfoTwo.recommendNo = res.data.recommendNo
        this.commodityInfoTwo.linkNo = res.data.linkNo
        this.registerIF = 1
        this.saveLoading = false
      }).catch(() => {
        this.registerIF = 0
        this.saveLoading = false
      })
    },
    titlesubmit() {
      if (this.buyQty <= 0) {
        return this.$message(this.$t('leastInputANumber'))
      }
      if (!this.payPassword) {
        return this.$message.error(this.$t('please.input.your.pay.password'))
      } else {
        let lists = []
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].buyQty > 0) {
            lists.push(this.list[i])
          }
        }
        this.commodityInfoTwo.goodsList = lists
      }
      this.commodityInfoTwo.payPassword = this.payPassword
      this.saveLoading = true
      saveSGA({ ... this.commodityInfoTwo}).then(() => {
        this.saveLoading = false
        this.$router.push({name:'OrderQuery'})
        this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
      }).catch(() => {
        this.saveLoading = false
        this.$message.error(this.$t('bdSendRegister.operaterFail'))
      })
    },
    recommendNoBlur(val) {
      if (val) {
        miMemberInfo({ 'memberNo': val}).then(res => {
          this.recommendName_span =  res.data.accountName
        }).catch(() => {
          this.recommendName_span =  ''
          this.recommendName_span_show = true
        })
      } else {
        this.recommendName_span =  ''
        this.recommendName_span_show = false
      }
    },
    tmpLinkNoBlur(val) {
      if (val) {
        miMemberRightNum({ 'memberNo': val}).then(res =>  {
          this.tmpLinkNo_span = res.data.name
          this.tmpLinkNo_num_span = res.data.num
        }).catch(() =>{
          this.tmpLinkNo_span = ''
          this.tmpLinkNo_num_span = ''
          this.tmpLinkNo_span_show = true
        })
      } else {
        this.tmpLinkNo_span = ''
        this.tmpLinkNo_num_span = ''
        this.tmpLinkNo_span_show = false
      }
    },
    paperNoBlur(val) {
      if (!val) {
        this.paperNoError = ''
        return false
      }
      if (this.BonusType === '13') {
        switch (this.registerInfo.paperType) {
          case '1':
              if (val.length !== 16) {
                this.paperNoError = this.$t('sys.error.paperno')
              }
              break;
          case '2':
            if (val.length !== 8) {
              this.paperNoError = this.$t('sys.error.paperno')
            }
            break;
          case '3':
            if (val.length !== 13) {
              this.paperNoError = this.$t('sys.error.paperno')
            }
            break;
        }
      }
    },
    btnRegisterInfoSave() {
      if(this.registerInfo.password.length < 8 || this.registerInfo.password.length > 16){
        return this.$message.error(this.$t('sysUser.password')+this.$t('sys.require.numandletter.cn'))
      }
      if(this.registerInfo.advPassword.length < 8 || this.registerInfo.advPassword.length > 16){
        return this.$message.error(this.$t('sysUser.repeatPassword')+this.$t('sys.require.numandletter.cn'))
      }
      if (this.registerInfo.password !== this.registerInfo.advPassword) {
        return this.$message.error(this.$t('error.password.not.accord')) // 两次密码不一致
      }
      this.saveLoading = true
      this.$refs['registerRef'].validate((valid) => {
        if (valid) {
          agentRegisterFirst(this.registerInfo).then(res => {
            this.registerIF = 3
            this.resSaveInfo = res.data
            this.commodityInfo.recommendNo = res.data.miMember.recommendNo
            this.commodityInfo.linkNo = res.data.poOrderVO.linkNo
            this.commodityInfo.name = res.data.miMember.name
            this.commodityInfo.paperType = res.data.miMember.paperType
            this.commodityInfo.paperNo = res.data.miMember.paperNo
            this.commodityInfo.bonusSendType = res.data.miMember.bonusSendType
            this.commodityInfo.mobile = res.data.miMember.mobile
            this.commodityInfo.accountBank = res.data.miMember.accountBank
            this.commodityInfo.accountName = res.data.miMember.accountName
            this.commodityInfo.accountCode = res.data.miMember.accountCode
            this.commodityInfo.officeTel = res.data.miMember.officeTel
            this.commodityInfo.storeAddr = res.data.miMember.storeAddr
            this.commodityInfo.storePost = res.data.miMember.storePost
            this.saveLoading = false
          }).catch(() => {
            this.saveLoading = false
            this.registerIF = 2
          })
        } else {
          this.saveLoading = false
        }
      })
    },
    btnSubmit() {
      if(this.buyQty <= 0){
        return this.$message(this.$t('leastInputANumber'))
      }
      if(!this.saveInfo.payPassword){
        return this.$message.error(this.$t('please.input.your.pay.password'))
      }else {
        let lists = []
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].buyQty > 0) {
            lists.push(this.list[i])
          }
        }
        this.resSaveInfo.poOrderVO.goodsList = lists
      }
      this.resSaveInfo.poOrderVO.payPassword = this.saveInfo.payPassword
      this.saveLoading = true
      agentRegisterSecond({ ...this.resSaveInfo }).then(() => {
        this.$router.push({name:'OrderQuery'})
        this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
        this.saveLoading = false
      }).catch(() => {
        this.$message.error(this.$t('bdSendRegister.operaterFail'))
        this.saveLoading = false
      })
    },
    // 取消按钮
    btnCancel() {
      this.$router.push({name:'OrderQuery'})
    },
    // 获取商品列表
    getGoodsList() {
      goodsListSGByMember().then(res=>{
        this.list = res.data
      })
    },
    // 获取公司的制度
    getBonusType() {
      getCompanyBonusType({'companyCode': this.companyCode}).then(res => {
        this.BonusType = res.data
      })
    },
    //国
    getCountry(){
      getLevel1AlRegions().then(res=>{
        this.country = res.data
      }).catch(err=>{
        console.error(err)
      })
    },
    //省
    getProvince(){
      if(!this.registerInfo.country){
        this.registerInfo.province = null
        this.registerInfo.city = null
        this.registerInfo.district = null
      }else {
        this.sltloading = true
        getAlRegionsByCode({'regionCode':this.registerInfo.country}).then(res=>{
          this.registerInfo.province = null
          this.registerInfo.city = null
          this.registerInfo.district = null
          this.province = res.data
          this.sltloading = false
        }).catch(err=>{
          this.sltloading = false
          console.error(err)
        })
      }
    },
    //市
    getcity(){
      this.sltloading = true
      getAlRegionsByCode({'regionCode':this.registerInfo.province}).then(res=>{
        this.registerInfo.city = null
        this.registerInfo.district = null
        this.city = res.data
        this.sltloading = false
      }).catch(err=>{
        this.sltloading = false
        console.error(err)
      })
    },
    //区
    getdistrict(){
      this.sltloading = true
      getAlRegionsByCode({'regionCode':this.registerInfo.city}).then(res=>{
        this.district = res.data
        this.sltloading = false
      }).catch(err=>{
        this.sltloading = false
        console.error(err)
      })
    }
  }
}
</script>

<style scoped lang="scss">
table {
  margin: 20px 0 20px 0px;
  width: 100%;
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  tr {
    th {
      width: 150px;
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      border: 1px solid black;
    }
    td {
      width: 200px;
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      border: 1px solid black;
    }
  }
  thead {
    th {
      font-size: 18px;
      border-right: 1px solid black;
      width: 400px;
    }
  }
  tbody {
    td {
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      font-size: 14px;
      border: 1px solid black;
      width: 200px;
    }
  }
}
.account_name_css:after {
  content: 'X';
  color: #ff4949;
}
.red-span {
  color: red;
}
.register_3_css {
  display: flex;
  ::v-deep .el-form-item {
    margin-bottom: 0px;
  }
}
</style>
